import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/vercel/path0/components/Nav.tsx");
